module.exports = __webpack_public_path__ + "static/media/logo.825936fe.png";